import * as React from "react";
import {
  ProgressBar,
  Text,
  makeStyles,
  tokens,
} from "@fluentui/react-components";

export type EnrichmentStep =
  | "reading"
  | "fetching"
  | "writing"
  | "thumbnails"
  | "done";

const STEP_LABELS: Record<EnrichmentStep, string> = {
  reading: "Reading article codes…",
  fetching: "Fetching enrichment data…",
  writing: "Writing to Excel…",
  thumbnails: "Inserting thumbnails…",
  done: "Complete",
};

const STEP_VALUES: Record<EnrichmentStep, number> = {
  reading: 0.15,
  fetching: 0.45,
  writing: 0.75,
  thumbnails: 0.9,
  done: 1,
};

export interface ProgressIndicatorProps {
  step: EnrichmentStep;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "12px 0",
  },
  label: {
    color: tokens.colorNeutralForeground2,
  },
});

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ step }) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Text className={styles.label}>{STEP_LABELS[step]}</Text>
      <ProgressBar value={STEP_VALUES[step]} />
    </div>
  );
};

export default ProgressIndicator;
